import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";


export const getTrendingSeries = createAsyncThunk("series/getTrendingSeries", async() => {
    const {data} = await axios.get("https://api.themoviedb.org/3/trending/tv/day?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5")
    return {data}
})


const tmSlice = createSlice({
    name:"trendingSeries",
    initialState:{
        data: null,
        isloading: false,
        error: null,
    },
    reducers:{},
    extraReducers:(builder) =>{
        builder.addCase(getTrendingSeries.pending,(state) => {
            state.isloading = true;
        })
        builder.addCase(getTrendingSeries.fulfilled,(state,action) => {
            state.isloading = false;
            state.data = action.payload
        })
        builder.addCase(getTrendingSeries.rejected,(state,action) => {
            state.isloading = false;
            state.error = action.payload.error
        })
    }

})

export default tmSlice.reducer